export default __webpack_public_path__ + "static/media/logoo.f52fdc45.png";